var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:_setup.classNames},[_c('FontAwesomeIcon',{attrs:{"icon":_setup.jwCrownIcon,"size":"sm"}}),_vm._v(" "+_vm._s(_vm.$t('WEBAPP_FREEMIUM_TAG'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }